import React, { useEffect, useRef, useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { Navigate } from 'react-router-dom'
import { getScheduledLiveStreams } from '../apis/youtube'
import { setAnnouncementBarToFirestore, setStreamsToFirestore, clearSavedStreams } from '../apis/firebase'
import 'materialize-css/dist/css/materialize.min.css';
import M from 'materialize-css';
import SyncVideos from '../components/SyncVideos'


export default function AdminDashboard() {
  const {user} = useAuth()
  const [status, setStatus] = useState('')
  const msg = useRef()
  const visible = useRef()
  const tabsRef = useRef()

  
  useEffect(() => {
    const tabs = M.Tabs.init(tabsRef.current)
    return () => {
      tabs.destroy()
    }
  }, [])

  if (!user) {
    return <Navigate to='/' replace={true}/>
  }

  const deleteStreams = async () => {
    await clearSavedStreams()
    setStatus('Deleted streams')
    await setTimeout(() => setStatus(''), 5000)
  }



  const syncStreamsWithFB = async () => {
    const streams = await getScheduledLiveStreams()
    console.log(streams)

    if (streams.length === 0) {
      setStatus('No streams found')
      await setTimeout(() => setStatus(''), 5000)
      return
    }

    await setStreamsToFirestore(streams)
    setStatus('Synced streams with Firebase')
    await setTimeout(() => setStatus(''), 5000)

    
  }

  const setAnnouncement = () => {
    setAnnouncementBarToFirestore(msg.current.value, visible.current.checked)
    setStatus('Announcement set')
    setTimeout(() => setStatus(''), 5000)
  }

  return (
    <div className='tos secondblue-bg'>
      <div className='container'>
        <h1 className='yellowtext'>Admin Dashboard</h1>
        <p className='yellowtext'>{status}</p>
        <div className='row'>
          <div className='col m2'>
            <ul className='tabs' ref={tabsRef}>
              <li className='tab'><a href='#stream-tab' className='yellowtext'>Streams</a></li>
              <li className='tab'><a href='#announcement-tab' className='yellowtext'>Announcement bar</a></li>
              <li className='tab'><a href='#video-tab' className='yellowtext'>Videos</a></li>
            </ul>
          </div>
          <div className='col m10'>
            <div id='stream-tab' className='tab-content'>
              <h4 className='yellowtext'>Streams</h4>
              <button className='yellowbtn' onClick={syncStreamsWithFB}>Sync Streams</button>
              <button className='yellowbtn' onClick={deleteStreams}>Delete Streams</button>
            
            </div>
            
            <div id='announcement-tab' className='tab-content'>
              <h4 className='yellowtext'>Announcement bar</h4>
              <div className='form yellowtext'>
                <div className='input-field'>
                  <input className='yellowtext' type='text' ref={msg} placeholder='New announcement'/>
                </div>
            
              <label className='yellowtext'>
                <input type="checkbox" ref={visible}/>
                <span>Visible</span>
              </label>  
            <br/>
            <br/>
            <button className='yellowbtn' onClick={setAnnouncement}>Set Announcement</button>
            </div>
            </div>

            <div id='video-tab' className='tab-content'>
              <SyncVideos/>
              
            </div>
            
            
            

          </div>
            
        </div>
        
        
        

        
          
    </div>
    </div>
    
  )
}
